import React, { useEffect, useMemo, useState } from "react";
import { classNames } from "../../helpers/classNames";

const Badge = ({ type, label = "Label", className, customColor }) => {
  const [statusColor, setStatusColor] = useState();
  const status = useMemo(
    () => ({
      success: "bg-gradient-to-r from-green-400 to-green-600 text-white border border-black/10",
      danger: "bg-gradient-to-r from-rose-500 to-rose-600 text-white border border-black/10",
      warning: "bg-gradient-to-r from-amber-400 to-amber-600 text-white border border-black/10",
      info: "bg-gradient-to-r from-sky-400 to-sky-600 text-white border border-black/10",
      indigo: "bg-gradient-to-r from-indigo-40 to-indigo-600 text-white border border-black/10",
      stone: "bg-gradient-to-r from-stone-400 to-stone-600 text-white border border-black/10",
      gold: "bg-gradient-to-r from-yellow-400 to-yellow-600 text-white border border-black/10",
      default: "bg-gradient-to-r from-gray-400 to-gray-600 text-white border border-black/10",
      "": "",
    }),
    []
  );

  useEffect(() => {
    if (type) {
      setStatusColor(status[type]);
    }
  }, [type]);

  return (
    <div
      className={classNames(
        "whitespace-nowrap truncate capitalize text-center py-[2px] px-2 rounded text-xs",
        customColor ? customColor : statusColor,
        className
      )}
    >
      {label}
    </div>
  );
};

export default Badge;
